// import DataObjectBaseClass from './Core';
function SAMAOffenderAssociation(aId) {
    "use strict";
    this.__type = 'SAMAOffenderAssociation:www.veritracks.com';
    this.Id = aId?aId:-1;
    this.SAMAId = '';
    this.EnrolleeId = 0;
    this.AppUserId = gUserDetails.UserId?gUserDetails.UserId:0;
}
SAMAOffenderAssociation.prototype = new DataObjectBaseClass();
SAMAOffenderAssociation.prototype.constructor = SAMAOffenderAssociation;

if (typeof exports !== 'undefined') {
    module.exports = SAMAOffenderAssociation;
}